import { CrudOp, tmmAuthScope } from "@org-avp/avp-avengers-ui-shared-auth";
import { TMMIcon } from "@org-avp/avp-avengers-ui-shared-icons";
import { Translations, ViewIsAuthorized, ViewModule } from "@org-avp/avp-avengers-ui-shared-utils";
import de from "../../public/locales/de.json";
import en from "../../public/locales/en.json";
import { TargetMaterialView } from "./lazy-view";

const translations: Translations = { de, en };
const isAuthorized: ViewIsAuthorized = (authHelperCreator, { project }) => {
  const authHelper = authHelperCreator(tmmAuthScope);
  return project != null && authHelper.evaluate(CrudOp.READ, project);
};

export const targetMaterialViewKey = "project_modular_target-material/:brand/:projectId/:subprojectId/:tmmId";
export const targetMaterialViewModule: ViewModule = {
  viewKey: targetMaterialViewKey,
  viewEl: <TargetMaterialView/>,
  displayNameI18nKey: "target-material:viewName",
  menuIconEl: <TMMIcon/>,
  isAuthorized,
  translations,
};
